import * as React from 'react'

import Svg, { ClipPath, Defs, G, Path } from 'react-native-svg'

import { IconProps } from '../icons'

const CreditScoreLow = ({ size = 20, color = '#000', ...props }: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <G clipPath="url(#a)">
      <Path
        d="M17.926 7.596A10.48 10.48 0 0 0 10.5 4.52v2.856a7.63 7.63 0 0 1 5.407 2.24l2.02-2.02Z"
        fill="#54A0FF"
      />
      <Path
        d="m3.073 7.596 2.02 2.02a7.63 7.63 0 0 1 5.407-2.24V4.52c-2.646 0-5.218.946-7.427 3.076Z"
        fill="#15BA8B"
      />
      <Path
        d="m3.073 7.596 2.02 2.02a7.63 7.63 0 0 1 5.407-2.24V4.52c-2.646 0-5.218.946-7.427 3.076Z"
        fill="#FECA57"
      />
      <Path
        d="M0 14.797a.19.19 0 0 0 .189.194h2.48c.1 0 .185-.08.188-.182a7.628 7.628 0 0 1 2.236-5.194l-2.02-2.02A10.477 10.477 0 0 0 0 14.798Z"
        fill="#FF6B6B"
      />
      <Path
        d="M4.374 7.516C6.164 5.79 8.19 4.834 10.3 4.522c-2.574.047-5.073.998-7.226 3.074l.643.642c.207-.25.427-.49.658-.722Z"
        fill="#DDB04D"
      />
      <Path
        d="M1.459 14.991a.191.191 0 0 1-.191-.196 10.584 10.584 0 0 1 2.448-6.557l-.643-.642A10.477 10.477 0 0 0 0 14.797a.19.19 0 0 0 .189.194h2.48-1.21Z"
        fill="#DA6A6A"
      />
      <Path
        d="m17.926 7.596-2.02 2.02a7.63 7.63 0 0 1 2.237 5.193.188.188 0 0 0 .189.182h2.479a.19.19 0 0 0 .189-.194 10.485 10.485 0 0 0-3.074-7.201Z"
        fill="#15BA8B"
      />
      <Path
        d="m11.395 11.072-4.894 1.74a.268.268 0 0 0-.068.47l4.2 3.058c1.831 1.334 4.425.241 4.75-2.002.324-2.242-1.853-4.026-3.988-3.266Z"
        fill="#434343"
      />
      <Path
        d="M14.624 13.323c-.325 2.243-2.918 3.335-4.75 2.001l-3.419-2.49a.267.267 0 0 0-.022.447l4.2 3.059c1.831 1.334 4.425.241 4.75-2.002a2.98 2.98 0 0 0-.995-2.694c.228.498.324 1.072.236 1.679Z"
        fill="#2C2B2B"
      />
      <Path
        d="M11.18 13.73a1.291 1.291 0 1 0 2.555.37 1.291 1.291 0 0 0-2.555-.37Z"
        fill="#fff"
      />
      <Path
        d="M11.175 14.067a1.292 1.292 0 1 0 1.793-1.339 1.292 1.292 0 0 1-1.793 1.339Z"
        fill="#AEA1A1"
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h21v18H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default CreditScoreLow
